import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateSwitch} from '#core/application/modules/tiles/switch/index.js';

export function betslipFreeBetsFactory(PALETTE) {
    return {
        FreeBetsList: {
            expandableView: {
                container: {
                    style: {
                        ...resolveBackground(PALETTE.BETSLIP_FREE_BETS_CONTAINER_BG),
                        padding: '0px',
                        overflow: 'initial hidden',
                    },
                },
                contentContainer: {
                    style: {
                        base: {
                            padding: 0,
                        },
                    },
                },
                headerContainer: {
                    style: {
                        base: {
                            minHeight: '40px',
                            padding: '0px 8px',
                        },
                    },
                },
                headerTextContainer: {
                    style: {
                        ...PALETTE.BETSLIP_FREE_BETS_HEADER_TEXT,
                    },
                },
                rotation: {
                    style: {
                        margin: '0', // Moj provides margin: '0 10px 0 0' which does not match Zeplin
                    },
                    image: {
                        style: {
                            fill: PALETTE.BETSLIP_FREE_BETS_HEADER_ROTATION_ICON_COLOR,
                            minWidth: 8, // Where they took this weird values ?
                        },
                    },
                },
            },
            freeBetView: {
                icon: {
                    style: {
                        display: 'none', // because Mojito doesn't provide us with proper config entries for this
                        minWidth: '0px',
                        flexBasis: '0',
                    },
                },
                container: {
                    style: {
                        borderStyle: 'none',
                        height: '40px',
                        padding: '0px 8px',
                    },
                },
                toggleButton: merge(generateSwitch(PALETTE.BETSLIP_FREE_BETS_SWITCH, {TRUNCATE_LABEL: true}), {
                    style: {
                        base: {
                            switch: {
                                height: '26px',
                                width: '26px',
                            },
                        },
                    },
                }),
            },
        },
    };
}
